/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/129-spinner7': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.5 14.5a1.5 1.5 0 113.001.001A1.5 1.5 0 016.5 14.5zM0 8a1.5 1.5 0 113.001.001A1.5 1.5 0 010 8zm13 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0113 8zM1.904 3.404a1.5 1.5 0 113.001.001 1.5 1.5 0 01-3.001-.001zm9.192 9.192a1.5 1.5 0 113.001.001 1.5 1.5 0 01-3.001-.001zm-9.192 0a1.5 1.5 0 113.001.001 1.5 1.5 0 01-3.001-.001zm9.192-9.192a1.5 1.5 0 113.001.001 1.5 1.5 0 01-3.001-.001z"/>'
  }
})
